// src/main.web.ts
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { createCustomElement } from '@angular/elements';

import { JobSidePreviewComponent } from './app/Modules/Job/Components/job-side-preview/job-side-preview.component';
import { MultipleSiteIdsInfo } from 'app/Modules/Job/Models/job-side-preview.model';
// ngx-translate
import { provideEnvironmentInitializer, importProvidersFrom, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
//import { TgSettingsService } from '../src/app/services/tg-settings.service';               // ← most likely
import { LCID_TO_LANG } from './app/services/Translate_Services/lcid-mapping';
import { TgSettingsService } from './app/services/TG-Setting_Services/tg-settings.service';

// Angular Material
import { AppComponent } from 'app/app.component';
import { TranslationInitService } from 'app/services/Translate_Services/translation-init.service';
import { TRANSLATION_CONFIG } from 'app/services/Translate_Services/translation-config.token';

console.log("loaded web standalone");
(window as any).appName = "JobSidePreview";
console.log((window as any).appName);
const DEFAULT_LANG = 'en-GB';
//const DEFAULT_LANG = 'en-GB';
function initializeAppFactory() {
  const tgSettingsService = inject(TgSettingsService);
  const translate = inject(TranslateService);
  const translationInit = inject(TranslationInitService);
  return async () => {
    try {
      const settings = await firstValueFrom(tgSettingsService.getSettings());
    } catch (err) {
      console.error('[Bootstrap Init] Initialization failed → fallback to en-GB', err);
      await firstValueFrom(translate.use(DEFAULT_LANG));
    }
  };
}
const TRANSLATION_PREFIX =
  '/TGNewUI/NG-Widgets/browser/assets/i18n/GlobalResources.';
const TRANSLATION_SUFFIX = '.json';
console.log('Translation files will be loaded from:', TRANSLATION_PREFIX, '*', TRANSLATION_SUFFIX);
const sharedProviders = [
  provideAnimations(),
  provideHttpClient(),
  provideTranslateService(),

  provideTranslateHttpLoader({
    prefix: TRANSLATION_PREFIX,
    suffix: TRANSLATION_SUFFIX
  }),

  {
    provide: TRANSLATION_CONFIG,
    useValue: {
      prefix: TRANSLATION_PREFIX,
      suffix: TRANSLATION_SUFFIX
    }
  },

  provideEnvironmentInitializer(initializeAppFactory),
  importProvidersFrom(MatDatepickerModule, MatNativeDateModule)
];


    bootstrapApplication(AppComponent, {
      providers: [
        sharedProviders
        // ✅ REQUIRED for HttpClient & services

        // provideTranslateHttpLoader(),


      ]
    })
      .then(appRef => {
        const injector = appRef.injector;



        // Register custom element
        const jobSidePreviewElement = createCustomElement(
          JobSidePreviewComponent,
          { injector }
        );


        customElements.define('app-job-side-preview', jobSidePreviewElement);

      })
      .catch(err => console.error('Bootstrap failed:', err));
